import { TrimUiManager } from '../ui/trim.ui.manager';
import * as lodash from 'lodash';
import { CommandBase, TrimCommandManager } from '../command/trim.command.manager';
import { TrimFrameController } from './frame/trim.frame-controller';
import { TrimEditableImageManager } from '../editable-image/trim.editable-image.manager';
import { TrimPanZoomManager } from '../pan-zoom/trim.pan-zoom.manager';
import { initPictureFlags, TrimImageController } from './image/trim.image-controller';
import { TrimImageEditableTool } from './image/trim.image-editable-tool';
import { TrimTextController } from './text/trim.text-controller';
import { TrimTextEvent } from './text/trim.text-event';
import { TrimEditableSideTool } from './trim.editable-side-tool';
import { TrimImageEvent } from './image/trim.image-event';
import { TrimDataManager } from '../data/trim-data.manager';
import { PathType, TrimImageEditManager } from './trim.image-edit.manager';
import { TrimCjContainer, TrimCjCorner } from '../../model/cj-factory';
import { CJ_CONTAINER_NAME } from '../../model/cj-factory/trim.cj-obj-name.collection';
import { TrimCjTool } from '../../../utilities/trim.cj-tool';
import { TrimRulerManager } from '../ruler/trim.ruler.manager';
import { FitChecker } from '../../../utilities/fit-checker';
import { TrimPrintManager, TrimPrint } from '../../print/trim.print';
import { TrimTrimmingManager } from '../trimming/trim.trimming.manager';
import { store } from '../../../app/store';
import { TrimPosManager } from '../pos/trim.pos.manager';
import { cloneDeep } from 'lodash';

export class TrimEditableEvent {
  private stage: TrimCjContainer;
  private path: PathType;
  private url: string;
  private pageId: string;


  private editableImageManager!: TrimEditableImageManager;
  private commandManager!: TrimCommandManager;
  private panZoomManager!: TrimPanZoomManager;
  private frameController!: TrimFrameController;
  private imageController!: TrimImageController;
  private imageEditableTool!: TrimImageEditableTool;
  private textController!: TrimTextController;
  private textEvent!: TrimTextEvent;
  private editableSideTool!: TrimEditableSideTool;
  private imageEvent!: TrimImageEvent;
  private trimDataManager!: TrimDataManager;
  private rulerManager!: TrimRulerManager;
  private trimmingManager!: TrimTrimmingManager;
  private posManager!: TrimPosManager;
  private albumManager!: TrimPrintManager;
  private imageEditManager!: TrimImageEditManager;

  listenerList: TrimUiManager[] = [];
  private listenerId: any;
  private targetFrame: TrimCjContainer | null = null;
  private firstTargetFrame: TrimCjContainer | null = null;

  constructor(stage: TrimCjContainer, path: PathType, url: string, pageId: string) {
    this.stage = stage;
    this.path = path;
    this.url = url;
    this.pageId = pageId;
  }

  di(
    frameController: TrimFrameController,
    imageController: TrimImageController,
    commandMng: TrimCommandManager,
    editableMng: TrimEditableImageManager,
    panZoomMng: TrimPanZoomManager,
    imageEditableTool: TrimImageEditableTool,
    textController: TrimTextController,
    textEvent: TrimTextEvent,
    editableSideTool: TrimEditableSideTool,
    imageEvent: TrimImageEvent,
    layoutStoreMng: TrimDataManager,
    rulerMng: TrimRulerManager,
    trimmingMng: TrimTrimmingManager,
    posMng: TrimPosManager,
    albumManager: TrimPrintManager,
    imageEditMng: TrimImageEditManager,
  ): void {
    this.frameController = frameController;
    this.imageController = imageController;
    this.commandManager = commandMng;
    this.editableImageManager = editableMng;
    this.panZoomManager = panZoomMng;
    this.imageEditableTool = imageEditableTool;
    this.textController = textController;
    this.textEvent = textEvent;
    this.editableSideTool = editableSideTool;
    this.imageEvent = imageEvent;
    this.trimDataManager = layoutStoreMng;
    this.rulerManager = rulerMng;
    this.trimmingManager = trimmingMng;
    this.posManager = posMng;
    this.albumManager = albumManager;
    this.imageEditManager = imageEditMng;
  }

  initialize(): void {
  }

  destroy(): void {
    this.listenerList = [];
    this.targetFrame = null;
  }

  update(stage: TrimCjContainer, path: PathType, url: string): void {
    this.stage = stage;
    this.path = path;
    this.url = url;
  }

  // - 操作イベント設定 -
  async setEvent() {
    return new Promise<void>((resolve) => {
      this.listenerList = [
        TrimUiManager.ins.on('r->t:dis-select', () => {
          if (this.textEvent.targetFrame) {
            this.disFocused(this.textEvent.targetFrame);
          } else if (this.imageEvent.targetFrame) {
            this.disFocused(this.imageEvent.targetFrame);
          }
        }),
        TrimUiManager.ins.on('r->t:change-allow-margin', this.changeAllowMargin),
        // 内接外接の切り替え
        TrimUiManager.ins.on('r->t:image-resize-in/out/eq', async (v) => {
          if (this.imageEditManager.printMenu.modeInOut !== v.mode) {
            console.log(v.mode);
            this.imageEditManager.printMenu.modeInOut = v.mode;
            await this.imageEditableTool.reLayoutImage();
          }
        }),
        // -- 有効保障エリア切り替え --
        TrimUiManager.ins.on('r->t:image-guide-on/off', (v) => {
          if (v.mode === 'on') {
            TrimCjTool.getGuidContainer(this.stage).visible = true;
            // this.albumManager.currentPrint && (this.albumManager.currentPrint.isGuide = true);
            this.sortContainer();
          } else {
            TrimCjTool.getGuidContainer(this.stage).visible = false;
            // this.albumManager.currentPrint && (this.albumManager.currentPrint.isGuide = false);
          }
          this.trimDataManager.changeGuideMode(v.mode);
          this.imageEditManager.printMenu.modeAbleArea = v.mode;
        }),
        // -- shift移動 --
        TrimUiManager.ins.on('r->t:shift-move', (v) => {
          const currentFrame = this.imageEvent.targetFrame;
          const focusMode = this.trimDataManager.getFocusMode();
          if (!currentFrame || focusMode === 'scale' || focusMode === 'none') return;
          if (store.getState().dialog.dialogs.length) return;
          // if (v.type) {
          //   if (focusMode !== 'rotate') return;
          // }
          let target: TrimCjContainer;
          switch (focusMode) {
            case 'rotate':
            case 'dai':
              target = TrimCjTool.getPhotoContainer(currentFrame);
              break;
            case 'move':
              target = TrimCjTool.getDefaultContainer(currentFrame);
              break;
            case 'png':
              target = currentFrame;
              break;
            default:
              target = currentFrame;
              break;
          }
          const movePos = focusMode === 'move'
            ? TrimCjTool.getImageAreaContainer(target).movePos
            : target.movePos;

          const resetDialog = async (fnc?: () => void) => {
            await new Promise<void>((resolve) => {
              target.y += v.y;
              target.x += v.x;
              movePos.x += v.x;
              movePos.y += v.y;
              resolve();
            });

            TrimUiManager.ins.emit('t->r:push-dialog', {
                title: '確認',
                message: [
                  // '画像を写真フレームの外にレイアウトすることはできません。',
                  '配置された位置が適切ではありません。',
                  '元の位置に戻します。',
                ],
                buttons: [
                  {
                    label: 'OK',
                    callback: () => {
                      target.y! -= (v.y + 1);
                      target.x! -= (v.x + 1);
                      movePos.x -= (v.x + 1);
                      movePos.y -= (v.y + 1);
                      fnc?.();
                    },
                  },
                ],
              },
            );
          };
          switch (currentFrame.name) {
            case CJ_CONTAINER_NAME.editor:
              const guid = TrimCjTool.getGuidContainer(this.stage);
              if (!guid) break;
              if (!TrimCjTool.hitTest(currentFrame, guid)) {
                resetDialog();
                return;
              }
              break;
            case CJ_CONTAINER_NAME.image:
              if (focusMode === 'png') break;
              const frameContainer = TrimCjTool.getFrameContainer(target);
              if (!frameContainer) break;
              if (!TrimCjTool.hitTest(currentFrame, frameContainer, {
                adjustOrigin: { x: TrimCjCorner.maxIconSize / 2, y: TrimCjCorner.maxIconSize / 2 },
              })) {
                resetDialog();
                return;
              }
              break;
            default:
              break;
          }
          const isRotate = (focusMode === 'rotate') ? TrimCjTool.getRotateContainer(target).isRotate : false;
          const prevBase = (focusMode === 'rotate' || focusMode === 'dai')
            ? TrimCjTool.getDefaultContainer(target)
            : target;
          const prevTarget = cloneDeep(target);
          const prevMovePos = cloneDeep(movePos);
          target.x += v.x;
          target.y += v.y;
          movePos.x += v.x;
          movePos.y += v.y;
          let isMargin = false;
          if (focusMode === 'rotate' || focusMode === 'png') {
            const isToast = FitChecker.checkImageOneOutBounds(target);
            if (this.imageEditManager.printMenu.isAllowMargin) {
              this.imageEditManager.isFit = isToast;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
            }
            if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
              isMargin = true;
            }
          }
          target.x -= v.x;
          target.y -= v.y;
          movePos.x -= v.x;
          movePos.y -= v.y;
          this.action(
            'shift-move',
            `${v.x} ${v.y}移動`,
            () => {
              if (focusMode === 'rotate' || focusMode === 'dai') {
                this.imageEditableTool.imageMode(prevBase);
              }
              if (isMargin) {
                const _pos = FitChecker.findClosestValidPosition(target, {x: prevTarget.x, y: prevTarget.y}, {x: target.x, y: target.y});
                target.x = _pos.x;
                target.y = _pos.y;
                movePos.x = prevMovePos.x;
                movePos.y = prevMovePos.y;
                return;
              }
              target.x += v.x;
              target.y += v.y;
              movePos.x += v.x;
              movePos.y += v.y;
              if (focusMode === 'rotate' || focusMode === 'png') {
                const isToast = FitChecker.checkImageOneOutBounds(target);
                this.imageEditManager.isFit = isToast;
                TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
              }
            },
            () => {
              if (focusMode === 'rotate' || focusMode === 'dai') {
                this.imageEditableTool.imageMode(prevBase);
              }
              if (isMargin) {
                const _pos = FitChecker.findClosestValidPosition(target, {x: prevTarget.x, y: prevTarget.y}, {x: target.x, y: target.y});
                target.x = _pos.x;
                target.y = _pos.y;
                movePos.x = prevMovePos.x;
                movePos.y = prevMovePos.y;
                return;
              }
              target.x -= v.x;
              target.y -= v.y;
              movePos.x -= v.x;
              movePos.y -= v.y;
              if (focusMode === 'rotate' || focusMode === 'png') {
                const isToast = FitChecker.checkImageOneOutBounds(target);
                this.imageEditManager.isFit = isToast;
                TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
              }
            },
          );
          if (focusMode === 'rotate' || focusMode === 'dai') {
            const isToast = FitChecker.checkImageOneOutBounds(target);
            this.imageEditManager.isFit = isToast;
            TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
          }
        }),
        TrimUiManager.ins.on('r->t:resize', (v) => {
          const currentFrame = this.imageEvent.targetFrame;
          if (!currentFrame) return;
          const focusMode = this.trimDataManager.getFocusMode();
          if (focusMode !== 'rotate' && focusMode !== 'dai') return;
          const target = focusMode === 'rotate' || focusMode === 'dai'
            ? TrimCjTool.getPhotoContainer(currentFrame)
            : TrimCjTool.getDefaultContainer(currentFrame);
          target.scaleX += v.scale;
          target.scaleY += v.scale;
          let isMargin = false;
          if (focusMode === 'rotate' || focusMode === 'dai') {
            const isToast = FitChecker.checkImageOneOutBounds(target);
            if (this.imageEditManager.printMenu.isAllowMargin) {
              this.imageEditManager.isFit = isToast;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
            }
            if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
              isMargin = true;
            }
          }
          target.scaleX -= v.scale;
          target.scaleY -= v.scale;
          this.action(
            'scale',
            `${v.scale} 拡大/縮小`,
            () => {
              if (isMargin) {
                const _scale = FitChecker.findClosestValidScale(target, target.defaultScale, target.scaleX + v.scale);
                target.set({
                  scaleX: Math.round(_scale * 100) / 100,
                  scaleY: Math.round(_scale * 100) / 100,
                });
                return;
              }
              target.scaleX += v.scale;
              target.scaleY += v.scale;
              const focusMode = this.trimDataManager.getFocusMode();
              if (focusMode !== 'rotate' && focusMode !== 'dai') {
                TrimImageController.updateImageView(target);
              }
            },
            () => {
              if (isMargin) {
                const _scale = FitChecker.findClosestValidScale(target, target.defaultScale, target.scaleX + v.scale);
                target.set({
                  scaleX: Math.round(_scale * 100) / 100,
                  scaleY: Math.round(_scale * 100) / 100,
                });
                return;
              }
              target.scaleX -= v.scale;
              target.scaleY -= v.scale;
              const focusMode = this.trimDataManager.getFocusMode();
              if (focusMode !== 'rotate' && focusMode !== 'dai') {
                TrimImageController.updateImageView(target);
              }
            },
          );
          if (focusMode === 'rotate' || focusMode === 'dai') {
            const isToast = FitChecker.checkImageOneOutBounds(target);
            this.imageEditManager.isFit = isToast;
            TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
          }
        }),
        // -- 回転 --
        TrimUiManager.ins.on('r->t:rotate', (v) => {
          if (!this.imageEvent.targetFrame) return;
          const focusMode = this.trimDataManager.getFocusMode();
          if (v.type) {
            if (focusMode !== 'rotate' && focusMode !== 'dai') return;
          }
          const target = this.imageEvent.targetFrame;
          const prevBase = (focusMode === 'rotate' || focusMode === 'dai')
            ? TrimCjTool.getDefaultContainer(target)
            : target;
          this.imageEditableTool.rotate(v.angle, prevBase);
          let isMargin = false;
          if (focusMode === 'rotate' || focusMode === 'dai') {
            const isToast = FitChecker.checkImageOneOutBounds(target);
            if (this.imageEditManager.printMenu.isAllowMargin) {
              this.imageEditManager.isFit = isToast;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
            }
            if (isToast && !this.imageEditManager.printMenu.isAllowMargin) {
              isMargin = true;
            }
            this.imageEditableTool.rotate(-v.angle, prevBase);
          }
          this.action(
            'rotate',
            `${v.angle}度回転`,
            () => {
              if (focusMode === 'rotate' || focusMode === 'dai') {
                this.imageEditableTool.imageMode(prevBase);
              }
              this.imageEditableTool.rotate(v.angle, prevBase, isMargin);
            },
            () => {
              if (focusMode === 'rotate' || focusMode === 'dai') {
                this.imageEditableTool.imageMode(prevBase);
              }
              this.imageEditableTool.rotate(-v.angle, prevBase, isMargin, true);
            },
          );
        }),
        // -- 削除 --
        TrimUiManager.ins.on('r->t:delete', () => {
          console.log(this.imageEvent.targetFrame);
          if (!this.imageEvent.targetFrame) return;
          const target = this.imageEvent.targetFrame;
          const focusMode = this.trimDataManager.getFocusMode();
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [
              `この写真枠を削除します。`,
              `実行する場合「はい」、キャンセルする場合「いいえ」を選択してください。`,
            ],
            buttons: [
              {
                label: 'いいえ',
                callback: () => {
                },
              },
              {
                label: 'はい',
                callback: () => {
                  this.stage.removeChild(target);
                  this.editableImageManager.toUnUse(target.editableImageId ?? '');
                  TrimUiManager.ins.emit('t->r:dis-select');
                  this.action(
                    'delete',
                    `${target.name} を削除`,
                    () => {
                      this.imageEditableTool.remove(target, focusMode);
                    },
                    () => {
                      this.imageEditableTool.repairer(target, focusMode, target);
                    },
                  );
                  return;
                },
              },
            ],
          });

        }),
        // -- 複製 --
        // TrimUiManager.ins.on('r->t:clone', () => {
        //   TrimUiManager.ins.emit('t->r:push-dialog', {
        //     title: '確認',
        //     message: [
        //       `写真枠をコピーします。新しい写真枠は右下に重ねて作成されます。`,
        //       `実行する場合「はい」、キャンセルする場合「いいえ」を選択してください。`,
        //     ],
        //     buttons: [
        //       {
        //         label: 'いいえ',
        //         callback: () => {
        //         },
        //       },
        //       {
        //         label: 'はい',
        //         callback: () => {
        //           const target = this.imageEditableTool.clone();
        //           if (!target) return;
        //           const containers: TrimCjContainer[] = this.layoutDataManager.selector('getImageAreas', this.pageId);
        //           let count = 0;
        //           for (const con of containers) {
        //             const isPhoto = TrimCjTool.checkPhotoInFrame(con);
        //             if (isPhoto) {
        //               count++;
        //             }
        //           }
        //           const album: TrimPrint = this.layoutDataManager.selector('getCurrentPage');
        //           this.action(
        //             'clone',
        //             `${target?.name} を複製`,
        //             () => {
        //               this.imageEditableTool.repairer(target, 'scale', undefined, undefined, { isCopy: true });
        //               TrimUiManager.ins.emit('t->r:count-photo', { album, photoCount: count + 1 });
        //             },
        //             () => {
        //               this.imageEditableTool.remove(target, 'scale', undefined, { isUndo: true });
        //               TrimUiManager.ins.emit('t->r:count-photo', { album, photoCount: count });
        //             },
        //             // ));
        //           );
        //         },
        //       },
        //     ],
        //   });
        // }),
        TrimUiManager.ins.on('r->t:move-mode', () => {
          this.imageEvent.frameMoveMode = true;
          this.imageEditableTool.move();
        }),

        // -- テキスト挿入開始 --
        TrimUiManager.ins.on('r->t:insert-text:start', (v) => {
          TrimUiManager.ins.emit('r->t:change-operation-cursor', { mode: 'text' });
          TrimUiManager.ins.emit('t->r:layout-menu-disabled', { isDisabled: true });
          this.textEvent.isActive = true;
          this.textEvent.isInsert = true;
          this.listenerId = this.stage.addEventListener('click', (e: any) => {
            const pos = this.posManager.canvasToBrowser({
              // container の外側の座標だから container の座標を引いとく
              x: this.stage.stage.mouseX - TrimImageEditManager.STAGE_CONTAINER_X,
              y: this.stage.stage.mouseY - TrimImageEditManager.STAGE_CONTAINER_Y,
            });
            TrimUiManager.ins.emit('t->r: post-text-pos', { pos });
            this.textEvent.isActive = false;
            this.textController.insertText(e, v.callback);
            window.setTimeout(() => this.textEvent.isInsert = false);
          }, true);
        }),
        // -- テキスト更新 --
        TrimUiManager.ins.on('r->t:reload-text', (v) => {
          const textContainer = this.trimDataManager.getText(v.textParam.id);
          if (!textContainer) return;
          const text = TrimCjTool.getText(textContainer as TrimCjContainer);
          this.textController.backupText = lodash.cloneDeep(text);
          this.textController.editText(v.textParam, this.textController.backupText!, false, false, v.callback);
        }),
        // -- テキスト挿入終了 --
        TrimUiManager.ins.on('r->t:insert-text:end', () => {
          this.textEvent.isInsert = false;
          this.textEvent.isActive = false;
          this.stage.removeEventListener('click', this.listenerId, true);
          TrimUiManager.ins.emit('r->t:change-operation-mode', { mode: 'select' });
          TrimUiManager.ins.emit('t->r:layout-menu-disabled', { isDisabled: false });
        }),
        // -- テキスト削除 --
        TrimUiManager.ins.on('r->t:delete-text', (v) => {
          const textContainer = this.trimDataManager.getText(v.id);
          if (!textContainer) return;
          this.stage.removeChild(textContainer);
          this.action(
            'textDelete',
            `テキストを削除。`,
            () => {
              this.stage.removeChild(textContainer);
              this.textController.textBox = this.textController.textBox.filter(v => v.textId !== textContainer.textId);
              this.trimDataManager.removeText(textContainer.textId ?? '');
            },
            () => {
              this.stage.addChild(textContainer);
              this.textController.textBox.push(textContainer);
              this.trimDataManager.setText(textContainer);
            },
          );
        }),
        // -- テキスト編集完了 --
        TrimUiManager.ins.on('r->t:finish-text-edit', (v) => {
          this.textController.finishTextEdit(v.id);
        }),
        // -- 中心線表示 --
        TrimUiManager.ins.on('r->t:center-line', (v) => {
          if (v.display) {
            this.editableSideTool.addCenterLine();
          } else {
            this.editableSideTool.removeCenterLine();
          }
        }),
        // -- ルーラーの表示 --
        TrimUiManager.ins.on(('r->t:ruler'), (v) => {
          if (v.display) {
            this.rulerManager.initialize();
            this.rulerManager.boot();
          } else {
            this.rulerManager.destroy();
          }
        }),
        // -- 画像の追加 --
        TrimUiManager.ins.on('r->t:add-editable-image', (v) => {
          this.editableSideTool.addImage(v.editableImage);
          // this.editableImageManager.toUse(v.editableImage.id);
        }),
        // -- 操作モード切り替え（選択・手のひら） --
        TrimUiManager.ins.on('r->t:change-operation-cursor', (v) => {
          if (v.mode === 'pan-zoom') {
            this.editableSideTool.lock();
          } else {
            this.editableSideTool.unlock();
          }
        }),
        // -- 初期化 --
        TrimUiManager.ins.on('r->t:reset', () => {
          if (!this.imageEvent.targetFrame) return;
          const focusMode = this.trimDataManager.getFocusMode();
          const target = this.imageEvent.targetFrame;

          const photo = focusMode === 'png'
            ? target
            : TrimCjTool.getPhotoContainer(target);
          const _photo = lodash.cloneDeep(photo);
          const _data = this.imageEvent.imageInitData.filter((v) => v.target.editableImageId === photo.editableImageId && v.target.photoAreaId === photo.photoAreaId);
          const data = _data[_data.length - 1];
          if (!data || !target) {
            return;
          }
          this.action(
            'reset',
            `初期化`,
            () => {
              photo.set({
                ...data.param,
              });
              this.imageEvent.updateToolPos('rotate', target);
              const isFit = FitChecker.checkImageOneOutBounds(photo);
              this.imageEditManager.isFit = isFit;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast: isFit, target });
            },
            () => {
              photo.set({
                ..._photo,
              });
              this.imageEvent.updateToolPos('rotate', target);
              const isFit = FitChecker.checkImageOneOutBounds(photo);
              this.imageEditManager.isFit = isFit;
              TrimUiManager.ins.emit('t->r:show-toast', { isToast: isFit, target });
            },
          );
        }),
        // -- 写真/写真枠切り替え --
        TrimUiManager.ins.on('r->t:change-image/frame', (v) => {
          const target = this.imageEvent.targetFrame;
          if (!target) return;
          if (v.mode === 'image') {
            this.imageEditableTool.imageMode(target);
          } else {
            this.imageEditableTool.frameMode(target);
          }
        }),
        // -- dragの検知 枠のハイライト --
        TrimUiManager.ins.on('r->t:editable-image:drag:check', (v) => {
          if (this.imageEvent.activeFocus) return;
          // --- 繰り返し範囲を編集中のページに絞る ---
          const container: TrimCjContainer = this.trimDataManager.getImageArea();
            const defaultContainer = TrimCjTool.getDefaultContainer(container);
            // --- ハイライトの抽出 ---
            const highlight = TrimCjTool.getHighlight(container);
            // --- hitTestに必要な処理 ---
            const point = container.globalToLocal(v.x, v.y);
            if (container.hitTest(point.x, point.y)) {
              // ---- 枠にハイライト ----
              if ((this.targetFrame === container && container.isChecked) || !highlight) return;
              highlight.visible = true;
              // ---- 写真をドロップできる ----
              container.isChecked = true;
              defaultContainer.mouseEnabled = false;
              this.targetFrame = container;
            } else {
              // ---- 枠外でハイライトの削除 ----
              if (!highlight) return;
              highlight.visible = false;
              // ---- 写真をドロップできない ----
              container.isChecked = false;
              defaultContainer.mouseEnabled = true;
              this.targetFrame = null;
            }
        }),

        TrimUiManager.ins.on('r->t:editable-image:drop', () => {
          if (this.imageEvent.activeFocus) {
            this.imageEditManager.activateAllFocus();
            return;
          }
          const target: TrimCjContainer = this.trimDataManager.getImageArea();
          TrimCjTool.getHighlight(target).visible = false;
          // ここにロゴの場合アラート
          if (!target) {
            this.imageEditManager.activateAllFocus();
            return;
          }
          if (target.logoFlag) {
            const highlight = TrimCjTool.getHighlight(target);
            TrimUiManager.ins.emit('t->r:push-dialog', {
              title: '確認',
              message: [
                `対象の写真エリアはロゴタイプのため、画像一覧からの配置はできません。`,
                `ファイルを直接、ドラッグ＆ドロップで配置して下さい。`,
              ],
              buttons: [{
                label: 'OK', callback: () => {
                  this.imageEditManager.activateAllFocus();
                  highlight.visible = false;
                },
              }],
            });
            return;
          }
          target.isChecked = false;
          const targetContainer = TrimCjTool.getScaleContainer(target);

          const dragImages = this.editableImageManager.dragging;
          const dragImage = this.editableImageManager.dragging[dragImages.length - 1];

          let count = 0;
          const isPhoto = TrimCjTool.checkPhotoInFrame(target);
          if (isPhoto) {
            count++;
          }
          const album: TrimPrint = this.trimDataManager.getCurrentPrint();

          this.action(
            'add-image',
            `${dragImage.name} を写真枠に追加`,
            () => {
              this.imageController.createPhotoImage(dragImage, targetContainer).then(() => {
                this.imageEditManager.activateAllFocus();
              });
              // -- アルバムにEditableID保管
              TrimUiManager.ins.emit('t->r:count-photo', { album, photoCount: count + 1 });
            },
            () => {
              if (this.imageEvent.isFocus && target) {
                this.disFocused(target);
              }
              const index = this.albumManager.currentPrint?.editableIDList.findIndex((v) => v === dragImage.id);
              if (index !== undefined && index > -1) this.albumManager.currentPrint?.editableIDList.splice(index, 1);
              const container = TrimCjTool.getRotateContainer(targetContainer);
              const image = TrimCjTool.getImageContainer(targetContainer);
              container.removeChild(image);
              const mask = TrimCjTool.getMaskContainer(targetContainer);
              mask.alpha = 1;
              try {
                // if (!usedIDList.includes(dragImage.id)) {
                this.editableImageManager.toUnUse(image.editableImageId ?? '');
                // }
              } catch {
              }
              TrimUiManager.ins.emit('t->r:count-photo', { album, photoCount: count });
              TrimUiManager.ins.emit('t->r:change-use-image-num', { type: 'decrement' });
            },
          );
        }),
        TrimUiManager.ins.on('r->t:editable-image:drop:direct', async (v) => {
          TrimUiManager.ins.emit('t->r:wait-loading', { message: '' });
          if (this.imageEvent.activeFocus) {
            this.imageEditManager.activateAllFocus();
            return;
          }
          const focusFrame: TrimCjContainer = this.trimDataManager.getImageArea();
          if (!v.index) {
            this.firstTargetFrame = focusFrame;
          }
          if (!focusFrame.isChecked) {
            this.imageEditManager.activateAllFocus();
            return;
          }
          focusFrame.isChecked = false;
          const targetContainer = TrimCjTool.getScaleContainer(focusFrame);
          let count = 0;
          const isPhoto = TrimCjTool.checkPhotoInFrame(focusFrame);
          if (isPhoto) {
            count++;
          }
          // this.imageController.createPhotoImage(v.editableImage, targetContainer, initPictureFlags).then((res) => {
          //   if (!res) {
          //     this.imageEditManager.activateAllFocus();
          //     v.callback?.();
          //   }
          // });
        }),

        TrimUiManager.ins.on('r->t:editable-image:drop:temp', (v) => {
          const container: TrimCjContainer = this.trimDataManager.getImageArea();

          const targetContainer = TrimCjTool.getScaleContainer(container);

          let count = 0;
          const isPhoto = TrimCjTool.checkPhotoInFrame(container);
          if (isPhoto) {
            count++;
            }
          this.imageController.createPhotoImage(v.editableImage, targetContainer).then(() => {
            v.callback();
          });
        }),
        TrimUiManager.ins.on('r->t:rotate-additional', () => {
          // 中枠再生成の前に設置途中の線を中断する
          this.trimmingManager.cancel();
          this.editableSideTool.rotateAdditional();
        }),
        TrimUiManager.ins.on('r->t:transform-additional', () => {
          // 中枠再生成の前に設置途中の線を中断する
          this.trimmingManager.cancel();
          this.editableSideTool.transformAdditional();
        }),
        TrimUiManager.ins.on('r->t:transparent-additional', (v) => {
          this.editableSideTool.transparentAdditional(v.type, v.callback);
        }),
        TrimUiManager.ins.on('r->t:change-middle-frame', (v) => {
          this.trimmingManager.changeFrame(v.id);
        }),
        TrimUiManager.ins.on('r->t:check:open-trim-menu', (v) => {
          if (!v.isOpen) {
            // 閉じる要求は必ず受け付けて状態を畳む
            this.trimmingManager.cancel();
            this.trimmingManager.disFocusFrame();
            this.trimmingManager.isOpen = false;
          }
          TrimUiManager.ins.emit('t->r:open-trim-menu', { isOpen: v.isOpen });
        }),
        TrimUiManager.ins.on('r->t:trim:start', (v) => {
          this.trimmingManager.start(v.trimData);
        }),
        TrimUiManager.ins.on('r->t:show-trim-line', () => {
          // if (this.editableSideTool.isCenterLine) {
          //   this.editableSideTool.removeCenterLine();
          // } else {
          //   this.editableSideTool.addCenterLine();
          // }
          this.trimmingManager.showTrim();
        }),
        TrimUiManager.ins.on('r->t:show-guide-line', (v) => {
          this.trimmingManager.showGuide(v.list);
        }),
        TrimUiManager.ins.on('r->t:show-select-guide', (v) => {
          this.trimmingManager.selectGuide(v.list);
        }),
        TrimUiManager.ins.on('r->t:create-guide:start', (v) => {
          if (this.trimmingManager.isSetGuide) {
            this.trimmingManager.changeVector(v.type);
          }
          this.trimmingManager.setGuide(v.type);
        }),
        TrimUiManager.ins.on('r->t:delete-guide', (v) => {
          this.trimmingManager.deleteGuide(v.id);
        }),
        TrimUiManager.ins.on('r->t:close-trim-menu', () => {
          this.trimmingManager.cancel();
          this.trimmingManager.disFocusFrame();
          this.trimmingManager.isOpen = false;
          // パネルの実開閉状態を購読側 ( toolbar等 ) へ通知する
          TrimUiManager.ins.emit('t->r:open-trim-menu', { isOpen: false });
        }),
        TrimUiManager.ins.on('r->t:shortcut:save-trim:focus-out', () => {
          if (this.imageEvent.isMove && this.imageEvent.dragTarget) {
            const container: TrimCjContainer = this.trimDataManager.getImageArea();
            TrimCjTool.getHighlight(container).visible = false;
          }
          if (this.trimmingManager) {
            if (this.trimmingManager.trimGuides) {
              this.trimmingManager.moveEnd();
            }
          }
          if (this.imageEvent.targetFrame) {
            this.disFocused(this.imageEvent.targetFrame, true);
          } else if (this.textEvent.targetFrame) {
            this.disFocused(this.textEvent.targetFrame);
          }
        }),
      ];
      resolve();
    });
  }

  changeAllowMargin = (v: { isAllowMargin: boolean }) => {
    this.imageEditManager.printMenu.isAllowMargin = v.isAllowMargin;
    if (!v.isAllowMargin) {
      const photo = this.trimDataManager.getImageArea();
      const isFit = FitChecker.checkImageOneOutBounds(photo);
      if (isFit) {
        this.imageEditManager.printMenu.modeInOut = 'out';
        TrimUiManager.ins.emit('t->r:image-resize-in/out/eq', {mode: 'out'});
        this.imageEditableTool.reLayoutImage();
      }
    }
  };

  cancelDraggingFunc() {
    const container: TrimCjContainer = this.trimDataManager.getEditor();
    const highlight = TrimCjTool.getHighlight(container);
    const imgAreaCon = TrimCjTool.getImageAreaContainer(container);
    highlight.visible = false;
    imgAreaCon.isChecked = false;
    container.mouseEnabled = true;
    this.targetFrame = null;
  }

  /** -- 正しい順番にソートする --
   * --- 上 ---
   * 1. ベースマスク(実はテンプレート形にくりぬいた黒い枠を被せている)
   * 2. テキスト
   * 3. 台紙タイプ時の中台紙
   * 4. オーバーラップ(一番上にくる装飾)
   * 5. ガイド(遊候補所エリア)
   * 6. PNG画像
   * 7. 写真枠 & 写真
   * 8. 背景
   * --- 下 ---
   * */
  sortContainer() {
    const frameLength = this.stage.numChildren;
    const edge = this.stage.getChildByName(CJ_CONTAINER_NAME.edge);
    const guide = this.stage.getChildByName(CJ_CONTAINER_NAME.guide);
    const bjImg = this.stage.getChildByName(CJ_CONTAINER_NAME.back);
    const base = this.stage.getChildByName(CJ_CONTAINER_NAME.base);
    const baseMask = this.stage.getChildByName(CJ_CONTAINER_NAME.baseMask);
    // const editor = TrimCjTool.getDefaultContainer(this.stage);
    const pngs = this.trimDataManager.getFreeGraphics();
    // const png = this.stage.getChildByName(CJ_CONTAINER_NAME.image);
    const texts = this.trimDataManager.getTexts();
    // guide && this.stage.setChildIndex(guide, frameLength - 1);
    // additional && this.stage.setChildIndex(additional, frameLength - 1);
    // png && this.stage.setChildIndex(png, frameLength - 1);

    // editor && this.stage.setChildIndex(editor, frameLength - 1);
    baseMask && this.stage.setChildIndex(baseMask, frameLength - 1);
    for (const png of pngs) {
      this.stage.setChildIndex(png, frameLength - 1);
    }
    for (const text of texts) {
      this.stage.setChildIndex(text, frameLength - 1);
    }
    base && this.stage.setChildIndex(base, 0);
    edge && this.stage.setChildIndex(edge, 0);
    guide && this.stage.setChildIndex(guide, this.stage.numChildren - 1);
  }

  private resetMask() {
    const frameLength = this.stage.numChildren;
    const baseMask = this.stage.getChildByName(CJ_CONTAINER_NAME.baseMask);
    baseMask && this.stage.setChildIndex(baseMask, frameLength - 1);
  }

  disFocused(target: TrimCjContainer, isDisFocus?: boolean): void {
    const focusMode = this.trimDataManager.getFocusMode();
    const frameLength = this.stage.numChildren;
    if (!target) return;
    if (focusMode === 'png') {
      if (this.imageEvent.activeFocus) {
        target.getChildByName(CJ_CONTAINER_NAME.focus.rotate).visible = false;
        TrimUiManager.ins.emit('t->r:dis-select');
        TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image-frame' });
        this.imageEditableTool.removeEvt(target);
        this.imageEvent.activeFocus = null;
        this.imageEvent.targetFrame = null;
        this.trimDataManager.setFocusMode('scale');
        // ツールチップを非表示にする
        TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
      }
      target && this.stage.setChildIndex(target, frameLength - 1);
      this.sortContainer();
      return;
    }
    if (this.imageEvent.activeFocus) {
      const isPhoto = TrimCjTool.checkPhotoInFrame(target);
      if (isDisFocus) {
        this.sortContainer();
      }

      if (target.name === CJ_CONTAINER_NAME.editor && isDisFocus) {
        this.sortContainer();
      }
      if (target.name === CJ_CONTAINER_NAME.image && isDisFocus) {
        const frameContainer = TrimCjTool.getFrameContainer(target) ?? TrimCjTool.getImageAreaContainer(target);
        if (!frameContainer) return;
        if (!TrimCjTool.hitTest(target, frameContainer, {
          adjustOrigin: { x: TrimCjCorner.maxIconSize / 2, y: TrimCjCorner.maxIconSize / 2 },
        })) {
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [
              '画像を写真フレームの外にレイアウトすることはできません。',
              '元の位置に戻します。',
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => {
                  TrimUiManager.ins.emit('r->t:reset');
                  this.disFocused(target);
                },
              },
            ],
          });
          return;
        }
      }
      this.imageEditManager.isDAI || (TrimCjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.scale).visible = false);
      this.imageEditManager.isDAI || (TrimCjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.move).visible = false);
      if (isPhoto) {
        TrimCjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.rotate).visible = false;
        TrimCjTool.getImageContainer(target).mouseEnabled = false;
      }
      TrimUiManager.ins.emit('t->r:dis-select');
      TrimUiManager.ins.emit('t->r:change-image/frame', { mode: 'image-frame' });
      this.imageEditableTool.removeEvt(target);
      this.imageEvent.activeFocus = null;
      this.imageEvent.isFocus = false;
      this.imageEvent.targetFrame = null;
      this.trimDataManager.setFocusMode('scale');
      // ツールチップを非表示にする
      TrimUiManager.ins.emit('t->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
      const editor = TrimCjTool.getDefaultContainer(target);
      const ima = TrimCjTool.getImageAreaContainer(target);
      editor && this.stage.setChildIndex(editor, ima.depth || frameLength - 3);
      this.sortContainer();
      this.resetMask();
      this.imageEvent.isFocus = false;
      if (this.trimmingManager) {
        this.trimmingManager.trimLines && this.stage.setChildIndex(this.trimmingManager.trimLines, frameLength - 1);
        this.trimmingManager.trimGuides && this.stage.setChildIndex(this.trimmingManager.trimGuides, frameLength - 1);
      }
      return;
    } else if (this.textEvent.isFocus) {
      const textFocus = TrimCjTool.getTextFocus(target);
      textFocus.visible = false;
      this.textEvent.isFocus = false;
      this.textEvent.targetFrame = null;
      target && this.stage.setChildIndex(target, frameLength - 1);
      this.sortContainer();
      this.resetMask();
      return;
    }
  }

  // undo/redo 設定
  action(
    name: string,
    description: string,
    redo: () => Promise<void> | void,
    undo: () => Promise<void> | void,
  ) {
    this.commandManager.do(new CommandBase(name, description, redo, undo));
  }
}
